(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.VOTealiumEventDedupe = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function normalizeRawValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function buildProductsSignature(products) {
    if (!products || typeof products !== 'object' || Array.isArray(products)) {
      return '0:';
    }

    const productKeys = Object.keys(products)
      .map((key) => normalizeRawValue(key))
      .filter(Boolean)
      .sort();

    return `${productKeys.length}:${productKeys.slice(0, 20).join(',')}`;
  }

  function applySearchFilteringFields(payload, facetValues) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return payload;
    }

    const normalizedFacetValues = normalizeRawValue(facetValues);

    delete payload.Events_SearchFiltering;
    delete payload.Search_FacetValues_String;

    payload.Events_SearchFiltering = '1';
    payload.Search_FacetValues_String = normalizedFacetValues;

    return payload;
  }

  function buildPlpPageViewSignature(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return '';
    }

    return [
      normalizeRawValue(payload.id),
      normalizeRawValue(payload.Page_Type),
      normalizeRawValue(payload.Page_Section1),
      normalizeRawValue(payload.Page_Section2),
      normalizeRawValue(payload.Page_Section3),
      normalizeRawValue(payload.Page_Country),
      normalizeRawValue(payload.Order_Currency),
      normalizeRawValue(payload.Search_FacetValues_String),
      buildProductsSignature(payload.Products),
    ].join('|');
  }

  function shouldSkipRecentPlpPageView(payload, targetWindow, ttlMs, now) {
    const scope =
      targetWindow && typeof targetWindow === 'object'
        ? targetWindow
        : typeof globalThis !== 'undefined'
          ? globalThis
          : {};
    const signature = buildPlpPageViewSignature(payload);
    const ttl = Number.isFinite(Number(ttlMs)) ? Number(ttlMs) : 1500;
    const timestamp = Number.isFinite(Number(now)) ? Number(now) : Date.now();

    if (!signature) {
      return false;
    }

    if (
      normalizeRawValue(scope.__voLastPlpPageViewSignature) === signature &&
      timestamp - (Number(scope.__voLastPlpPageViewTimestamp) || 0) < ttl
    ) {
      return true;
    }

    scope.__voLastPlpPageViewSignature = signature;
    scope.__voLastPlpPageViewTimestamp = timestamp;
    return false;
  }

  return {
    applySearchFilteringFields,
    buildPlpPageViewSignature,
    shouldSkipRecentPlpPageView,
  };
});
